import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type AlarmType =
  | "alarm_occlusion" // Occlusion detected (2)
  | "alarm_auto_off" // Auto Off (7)
  | "alarm_out_of_liquid" // Empty cartridge (8)
  | "alarm_temperature_out_of_range" // Temperature Out of Range (10)
  | "alarm_resume_pump" // Resume pump (18)
  | "alarm_altitude" // Altitude (21)
  | "alarm_generic" // Generic, always set when other alarms set (23)
  | "alarm_cartridge_removed" // Cartridge Removed (25)
  | "alarm_second_occlusion"; // Second Occlusion detected in a row (26)

export type AlarmActivatedPayload = {
  alarm_id: number;
};

export type AlarmActivatedEvent = {
  alarmId: number;
  alarmType?: AlarmType;
};

const alarmActivatedSchema = z.object({
  alarm_id: z.number(),
});

export const LID_ALARM_ACTIVATED = {
  value: 0x05,
  name: "Alarm Activated Event",
  format: "i............",
  fields: ["alarm_id"],
  postprocess: rec => ({
    alarmId: rec.alarm_id,
    alarmType: getAlarmType(rec.alarm_id),
  }),
  schema: alarmActivatedSchema,
} as const satisfies TandemEventDefinition<AlarmActivatedPayload, AlarmActivatedEvent>;

const getAlarmType = (alarmId: number): AlarmType | undefined => {
  switch (alarmId) {
    case 2:
      return "alarm_occlusion";
    case 7:
      return "alarm_auto_off";
    case 8:
      return "alarm_out_of_liquid";
    case 10:
      return "alarm_temperature_out_of_range";
    case 18:
      return "alarm_resume_pump";
    case 21:
      return "alarm_altitude";
    case 23:
      return "alarm_generic";
    case 25:
      return "alarm_cartridge_removed";
    case 26:
      return "alarm_second_occlusion";
    default:
      return undefined;
  }
};
